/** @format */
import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'pdp-custom-components-customizer-summary',
	templateUrl: './customizer-summary.component.html',
	styleUrl: './customizer-summary.component.scss',
	standalone: false
})
export class CustomizerSummaryComponent {
	@Input() customizedAttributes: { name: string; value: string }[];
	@Input() isCustomizationSelected: boolean;
	@Output() openCustomPanel = new EventEmitter<boolean>();

	constructor(
		public route: ActivatedRoute,
		public router: Router
	) {}

	public openEditCustomPanel() {
		this.openCustomPanel.emit(true);
	}

	trackByFn(index: number, item: { name: string; value: string }): string {
		return index.toString() + item.name + item.value;
	}
}
